module.exports = __webpack_public_path__ + "static/media/stockhausen_haum_02.44afa95f.jpg";